import lazyLoad from '@/functions/lazy-load'

const images = document.querySelectorAll('.js-lazy-load')

for (let i = 0; i < images.length; i++) {
  lazyLoad(images[i])
}
